(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["frequently-bought-together"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async function(event) {
  const button = event.target.closest('[data-bundle-add]');

  if (!button) return;

  const section = button.closest('.frequently-bought');

  const products = section.querySelectorAll(
    '.frequently-bought__product[data-variant-id]'
  );

  const items = [];

  products.forEach(function(product) {
    const variantId = product.dataset.variantId;

    if (variantId) {
      items.push({
        id: variantId,
        quantity: 1
      });
    }
  });

  console.log('Bundle items:', items);

  if (!items.length) {
    console.error('No valid variants found.');
    return;
  }

  const originalText = button.textContent;

  button.disabled = true;
  button.textContent = 'Adding...';

  try {

    const response = await fetch(
      window.Shopify.routes.root + 'cart/add.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      }
    );

    const data = await response.json();

    if (!response.ok) {
      console.error('Shopify cart error:', data);

      /*alert(
        data.description ||
        data.message ||
        'One or more products could not be added to cart.'
      );*/

      throw new Error(
        data.description ||
        data.message ||
        'Unable to add bundle'
      );
    }

    console.log('Added successfully:', data);

    window.location.href =
      window.Shopify.routes.root + 'cart';

  } catch (error) {

    console.error('Bundle error:', error);

    button.disabled = false;
    button.textContent = originalText;

  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-details-tabs"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-details-tabs').forEach(function (wrapper) {
      const tabs = wrapper.querySelectorAll('.product-details-tabs__tab');
      const panels = wrapper.querySelectorAll('.product-details-tabs__panel');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          const target = tab.dataset.tab;

          tabs.forEach(function (item) {
            item.classList.remove('is-active');
            item.setAttribute('aria-selected', 'false');
          });

          panels.forEach(function (panel) {
            panel.classList.remove('is-active');
            panel.hidden = true;
          });

          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          const activePanel = wrapper.querySelector(
            '[data-panel="' + target + '"]'
          );

          if (activePanel) {
            activePanel.classList.add('is-active');
            activePanel.hidden = false;
          }
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
